import { render } from "./RecordTableXQ.vue?vue&type=template&id=37201dfe&scoped=true"
import script from "./RecordTableXQ.vue?vue&type=script&lang=js"
export * from "./RecordTableXQ.vue?vue&type=script&lang=js"

import "./RecordTableXQ.vue?vue&type=style&index=0&id=37201dfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37201dfe"]])

export default __exports__